export default __webpack_public_path__ + "static/media/googleAnalytics.23e7da15.png";